export default __webpack_public_path__ + "static/img-cultura-1-c58c86513d7767f2868375b611ca5737.png";